import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar        from './components/Navbar';
import CheckInPage   from './pages/CheckInPage';
import RegisterPage  from './pages/RegisterPage';
import DashboardPage from './pages/DashboardPage';
import AdminPage     from './pages/AdminPage';

export default function App() {
  return (
    <BrowserRouter>
      <Navbar />
      <Routes>
        <Route path="/"          element={<CheckInPage />}   />
        <Route path="/register"  element={<RegisterPage />}  />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/admin"     element={<AdminPage />}     />
      </Routes>
    </BrowserRouter>
  );
}
